import React, { useState } from "react";
import Logo from "../assets/logo.png";
const TextMessage = ({ qrData }) => {
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>

      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="sign_up_form_body">
        <div className="sign_up_form_heading">
          You received message from {qrData?.first_name || ""}{" "}
          {qrData?.last_name || ""}
        </div>

        {/* make form for data  */}
        <div className="sign_up_form">
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="First Name"
              value={qrData?.text || ""}
              onChange={(e) => {}}
              style={{
                minHeight: "200px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextMessage;
